// extracted by mini-css-extract-plugin
export default {"borderCSS":"style_borderCSS__8XMHk","heartHeightWidth":"style_heartHeightWidth__BLKVr"};